import { createHttpAction } from '@securitize/ui-components';
import { GET_OPPORTUNITIES_NEXT } from './actionTypes';

export const getOpportunities = () => createHttpAction(GET_OPPORTUNITIES_NEXT).action;
